import adminLogService from '../../services/admin/AdminLogService'

export const adminLogModule = {
  namespaced: true,

  state: {
    logs: [],
    pagination: {
      total: 0,
      current_page: 1,
      per_page: 50,
      last_page: 1,
    },
    levels: [],
    file: null,
    loading: true,
  },

  mutations: {
    SET_LOGS(state, payload) {
      state.logs = payload.data || []

      if (payload.total !== undefined) {
        state.pagination = {
          total: payload.total,
          current_page: payload.current_page,
          per_page: payload.per_page,
          last_page: payload.last_page,
        }
      }
    },
    SET_LEVELS(state, levels) {
      state.levels = levels || []
    },
    SET_FILE(state, file) {
      state.file = file || null
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
  },

  actions: {
    async fetchLogs({ commit }, params = {}) {
      commit('SET_LOADING', true)

      try {
        const data = await adminLogService.getLogs(params)
        commit('SET_LOGS', data)
        commit('SET_LEVELS', data?.levels)
        commit('SET_FILE', data?.file)
        return data
      } finally {
        commit('SET_LOADING', false)
      }
    },
  },

  getters: {
    logs: (state) => state.logs,
    pagination: (state) => state.pagination,
    levels: (state) => state.levels,
    file: (state) => state.file,
    loading: (state) => state.loading,
  },
}
